import { TravelersService } from './TravelersService'
import type { TravelerInformation } from '@/shared/types/api.types'
import getTravelersUaeResponse from '@/shared/tests/mocks/responses/gettravellersuae.json'

export class TravelersServiceMock extends TravelersService {
  async getTravelQuoteUae(): Promise<TravelerInformation[]> {
    return Promise.resolve(getTravelersUaeResponse.list)
  }
}
